import React, { useState, useEffect, useRef } from "react";
import Items from '../items/Items';
import { tipoArticulos} from "../../data/catalogos"


const descriptionEditorOptions = { height: 100 };

const Servicios = props => {
        return (
        <Items title="Servicios" typeId={tipoArticulos.Mantenimiento} ></Items>
    );
}

export default Servicios;